import { computed, defineComponent, ref } from 'vue';
import { useDateFormat } from '@/composables/dateFormat';
import { useStore } from 'vuex';
import { EmergencyGetter } from '@/store/emergency/emergency.module';
import { Emergency } from '@/store/emergency/emergency.model';
import { EmergencyAnswerGetter } from '@/store/emergencyAnswer/emergencyAnswer.module';
import { EmergencyAnswer } from '@/store/emergencyAnswer/emergencyAnswer.model';
import { AccountGetter } from '@/store/account/account.module';
import { Role } from '@/store/role/role.model';
import EmergencyAnswerFormComponent from '@/components/emergencyAnswer/emergencyAnswerForm/EmergencyAnswerForm.vue';
import EmergencyAnswerAttachmentOffcanvasComponent from '@/components/emergencyAnswer/emergencyAnswerAttachmentOffcanvas/EmergencyAnswerAttachmentOffcanvas.vue';
import EmergencyAnswerAttachmentModalComponent from '@/components/emergencyAnswer/emergencyAnswerAttachmentModal/EmergencyAnswerAttachmentModal.vue';
import EmergencyAnswerAttachmentFormComponent from '@/components/emergencyAnswer/emergencyAnswerAttachmentForm/EmergencyAnswerAttachmentForm.vue';
import EmergencyAnswerImageModalComponent from '@/components/emergencyAnswer/emergencyAnswerImageModal/EmergencyAnswerImageModal.vue';

export default defineComponent({
  name: 'EmergencyAnswerComponent',
  components: {
    EmergencyAnswerFormComponent,
    EmergencyAnswerAttachmentOffcanvasComponent,
    EmergencyAnswerAttachmentModalComponent,
    EmergencyAnswerAttachmentFormComponent,
    EmergencyAnswerImageModalComponent,
  },
  props: {
    emergencyId: {
      type: Number,
    }
  },
  setup: (props) => {
    const dateFormat = useDateFormat();
    const store = useStore();
    const emergency = computed<Emergency | undefined>(() => store.getters[EmergencyGetter.BY_ID](props.emergencyId));
    const emergencyAnswers = computed<EmergencyAnswer[]>(() => store.getters[EmergencyAnswerGetter.ALL]);
    const emergencyAnswerId = computed<number | null>(() => emergencyAnswers.value.length !== 0 ? emergencyAnswers.value[0].id : null);
    const isLoading = computed(() => store.getters[EmergencyGetter.STATUS] === 'init' ||  store.getters[EmergencyGetter.STATUS] === 'loading');
    const role = computed<Role | undefined>(() => store.getters[AccountGetter.SINGLE_ROLE]);
    const isOrs = computed(() => role.value?.name === 'เจ้าหน้าที่ ส.กกภ.');
    const isProvince = computed(() => role.value?.name === 'เจ้าหน้าที่ประจำจังหวัด');
    const emergencyAnswerForm = ref<InstanceType<typeof EmergencyAnswerFormComponent>>();
    const emergencyAnswerAttachmentOffcanvas = ref<InstanceType<typeof EmergencyAnswerAttachmentOffcanvasComponent>>();
    const emergencyAnswerAttachmentModel = ref<InstanceType<typeof EmergencyAnswerAttachmentModalComponent>>();
    const emergencyAnswerAttachmentForm = ref<InstanceType<typeof EmergencyAnswerAttachmentFormComponent>>();
    const emergencyAnswerImageModal = ref<InstanceType<typeof EmergencyAnswerImageModalComponent>>();

    const answerClick = () => {
      emergencyAnswerForm.value?.show();
    };

    const editClick = () => {
      emergencyAnswerForm.value?.show();
    };

    const attachmentClick = () => {
      emergencyAnswerAttachmentModel.value?.show();
    };

    const uploadClick = () => {
      Promise.resolve(emergencyAnswerAttachmentModel.value?.hide())
        .then(() => emergencyAnswerAttachmentForm.value?.show());
    };

    const uploadClose = () => {
      Promise.resolve(emergencyAnswerAttachmentForm.value?.hide())
        .then(() => emergencyAnswerAttachmentModel.value?.show());
    };

    const imageClick = () => {
      emergencyAnswerImageModal.value?.show();
    };

    const showAttachment = () => {
      emergencyAnswerAttachmentOffcanvas.value?.show();
    };

    const thaiDate = (date: Date) =>
      dateFormat.toThaiDate(date, 'long');

    return {
      emergency,
      emergencyAnswers,
      isOrs,
      isProvince,
      isLoading,
      emergencyAnswerForm,
      emergencyAnswerAttachmentOffcanvas,
      emergencyAnswerAttachmentModel,
      emergencyAnswerAttachmentForm,
      emergencyAnswerImageModal,
      emergencyAnswerId,
      answerClick,
      editClick,
      attachmentClick,
      uploadClick,
      uploadClose,
      imageClick,
      showAttachment,
      thaiDate,
    };
  }
});
